import {connect} from "react-redux";
import AttendanceRegularizationList from "./List";
import {bindActionCreators} from "redux";
import {regularizationList} from "../../../service/AttendanceReqularization/action";

const mapStateToProps = (state) => ({
    attendanceList:state.AttendanceRegularization.attendanceList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            regularizationList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceRegularizationList);
